import { render, staticRenderFns } from "./ModalCreatFamille.vue?vue&type=template&id=264a8f0b&"
import script from "./ModalCreatFamille.vue?vue&type=script&lang=js&"
export * from "./ModalCreatFamille.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports